import { FC, ReactElement, cloneElement } from 'react'
import { Form, FormItemProps } from 'antd'
import ShowOnlyFormControl from '../ShowOnlyFormControl'
import { cn } from '@xhgj/xh-jsutils'

interface ReadOnlyFormItemProps extends FormItemProps {
  /** 是否为只读模式 */
  readOnly?: boolean
  /** 只读模式下的格式化函数 */
  formatValue?: (value: any) => any
  /** 只读模式下的后缀 */
  suffix?: string
  /** 表单控件 */
  children?: ReactElement
}

const ReadOnlyFormItem: FC<ReadOnlyFormItemProps> = ({
  readOnly = false,
  formatValue,
  suffix,
  children,
  ...formItemProps
}) => {
  return (
    <Form.Item
      {...formItemProps}
      className={cn('break-all', formItemProps?.className)}
    >
      {readOnly ? (
        <ShowOnlyFormControl formatValue={formatValue} suffix={suffix} />
      ) : (
        children
      )}
    </Form.Item>
  )
}

export default ReadOnlyFormItem
import { FC, ReactElement, cloneElement } from 'react'
import { Form, FormItemProps } from 'antd'
import ShowOnlyFormControl from '../ShowOnlyFormControl'
import { cn } from '@xhgj/xh-jsutils'

interface ReadOnlyFormItemProps extends FormItemProps {
  /** 是否为只读模式 */
  readOnly?: boolean
  /** 只读模式下的格式化函数 */
  formatValue?: (value: any) => any
  /** 只读模式下的后缀 */
  suffix?: string
  /** 表单控件 */
  children?: ReactElement
}

const ReadOnlyFormItem: FC<ReadOnlyFormItemProps> = ({
  readOnly = false,
  formatValue,
  suffix,
  children,
  ...formItemProps
}) => {
  return (
    <Form.Item
      {...formItemProps}
      className={cn('break-all', formItemProps?.className)}
    >
      {readOnly ? (
        <ShowOnlyFormControl formatValue={formatValue} suffix={suffix} />
      ) : (
        children
      )}
    </Form.Item>
  )
}

export default ReadOnlyFormItem
